import { LocalNotifications } from '@capacitor/local-notifications';
import { isNativeApp } from './runtime';

export function buildSpoilerSafeReminder(id: number, date: Date) {
  return {
    id,
    title: 'Your spoiler-free replay plan is ready',
    body: 'Open skore to choose what to watch. Scores stay hidden.',
    schedule: { at: date },
    extra: { destination: '/plan' },
  };
}

export async function scheduleReminder(id: number, date: Date): Promise<'scheduled' | 'denied' | 'unavailable'> {
  if (!isNativeApp()) return 'unavailable';
  let permission = await LocalNotifications.checkPermissions();
  if (permission.display === 'prompt') permission = await LocalNotifications.requestPermissions();
  if (permission.display !== 'granted') return 'denied';
  await LocalNotifications.cancel({ notifications: [{ id }] });
  await LocalNotifications.schedule({ notifications: [buildSpoilerSafeReminder(id, date)] });
  return 'scheduled';
}

export async function cancelReminder(id: number): Promise<void> {
  if (!isNativeApp()) return;
  await LocalNotifications.cancel({ notifications: [{ id }] });
}

